import { useEffect, useState } from "react";
import { getProjectsByList } from "../../dataApi/getProjects";
import { ProjectsEntity } from "../../types/list";

export const useProjects = () => {
  // todo: get all projects
};

export const useProjectsByList = (id: string) => {
  const [projects, setProjects] = useState<ProjectsEntity[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      const projectsData = await getProjectsByList(id);
      setProjects(projectsData);
      setLoading(false);
    })();
  }, []);

  return { projects, loading };
};
